<div
	class="input"
	[ngClass]="{
		'focus': focus,
		'error': msgError,
		'readonly': readonly,
		'focus-left': isComboSearch,
		'elastic': isElasticSearch,
		'white_background': white_background
	}"
>
	<img class="searchImg" *ngIf="isElasticSearch" src="assets/images/search.png" alt="search" srcset="assets/images/search.png" />
  <ng-container *ngIf="type == 'date' || type == 'time' || type == 'datetime-local'">
    <h5 *ngIf="help">{{ help }}</h5>

    <input
      #input
      [type]="type"
      [disabled]="disabled"
      [maxlength]="maxLength"
      (focus)="focus = true"
      (focusout)="focus = false"
      [ngClass]="{ full: full(), search: isComboSearch }"
      [(ngModel)]="value"
      (blur)="onBlur()"
      autocomplete="off"
      [readonly]="readonly"
      [placeholder]="placeholder"
      onlyNumbers   [condition]="isNumberRequired"
      [ngStyle]="{ '--custom-height': inputHeight }" 
    />
    <label class="label-date" >{{ label }}</label>
  </ng-container>
  <ng-container *ngIf="type !== 'date' && type !== 'time' && type !== 'datetime-local'">
    <div class="input-wrapper">
    <input
    *ngIf="addminSuffix"
    addminsffix
    #input
    [type]="type"
    [disabled]="disabled"
    [maxlength]="maxLength"
    (focus)="focus = true"
    (focusout)="focus = false"
    [ngClass]="{ full: full(), search: isComboSearch }"
    [(ngModel)]="value"
    (blur)="onBlur()"
    onlyNumbers [condition]="isNumberRequired" 
    autocomplete="off"
    [placeholder]="placeholder"
    [readonly]="readonly"
    [ngStyle]="{ '--custom-height': inputHeight }" >
    <input
      *ngIf="!addminSuffix && !percentagePromo"
      #input
      [type]="type"
      [disabled]="disabled"
      [maxlength]="maxLength"
      (focus)="focus = true"
      (focusout)="focus = false"
      [ngClass]="{ full: full(), search: isComboSearch, colorW:  upLabel === true && value !== '' && value !== null  }"
      [(ngModel)]="value"
      (blur)="onBlur()"
      onlyNumbers [condition]="isNumberRequired" 
      autocomplete="off"
      [placeholder]="placeholder"
      [readonly]="readonly"
      [ngStyle]="{ '--custom-height': inputHeight }" 
    />
    <input
    *ngIf="percentagePromo"
    percentagePromo
    #input
    [type]="type"
    [disabled]="disabled"
    [maxlength]="maxLength"
    (focus)="focus = true"
    (focusout)="focus = false"
    [ngClass]="{ full: full(), colorW: upLabel && value !== '' && value !== null, search: isComboSearch }"
    [(ngModel)]="value"
    (blur)="onBlur()"
    onlyNumbers [condition]="isNumberRequired" 
    autocomplete="off"
    [placeholder]="placeholder"
    [readonly]="readonly"
    [ngStyle]="{ '--custom-height': inputHeight }" >
    <label [ngClass]="{'upLabel': upLabel === true}">{{ label }}</label>
    <div [ngClass]="{'fondValue': upLabel === true && value !== '' && value !== null}"></div>
  <p
  *ngIf="showCharCounter"
  class="char-counter"
  [ngClass]="{
    'warn': value?.length >= recommendedLimit * 0.9 && value?.length <= recommendedLimit,
    'over': value?.length > recommendedLimit
  }"
>
  ({{ value?.length || 0 }}/{{ recommendedLimit }})
</p>
</div>
  </ng-container>
  <span *ngIf="msgError" [ngClass]="ErrorTitle === true ? 'titleError' : 'msgError'">{{ msgError }}</span>
  <a (click)="iconFuncion()">	
    <i *ngIf="icon" [ngClass]=" icon !== 'search' ? 'iconlarge fa fa-' + icon : ' fa fa-' + icon"  ></i>
  </a>
</div>
